export interface FAQ {
  question: string;
  answer: string;
}

export const faqList: FAQ[] = [
  {
    question: '什么是「高清无码」视频？它与普通高清视频有什么区别？',
    answer: '「高清无码」视频指的是在编码过程中采用高质量参数设置、尽可能保留原始画面细节的视频内容。「无码」在此语境下并非指无马赛克，而是强调视频编码过程中尽量减少压缩伪影、色带、块效应等视觉缺陷。与普通高清视频相比，「高清无码」视频在编码时使用更高的码率、更优的编码预设和更先进的编码标准，从而在相同分辨率下呈现出更加清晰、细腻的画面质量。',
  },
  {
    question: 'H.265/HEVC 和 H.264/AVC 选哪个更好？',
    answer: '如果你的播放设备和平台支持 H.265 解码（目前大多数现代设备都支持），强烈推荐使用 H.265。在相同画质下，H.265 可比 H.264 节省约 40%-50% 的码率，或在相同码率下提供明显更好的画质。但如果你的目标受众使用较旧的设备，H.264 仍然是兼容性最好的选择。一个实用的策略是同时提供两个版本，让播放器根据设备能力自动选择。',
  },
  {
    question: '无损编码和有损编码在实际使用中如何选择？',
    answer: '无损编码（如 FFV1、ProRes 4444 XQ）主要用于视频存档、专业后期制作的中间文件，以及需要反复编辑的项目。它们文件体积巨大（通常是有损编码的 5-20 倍），不适合网络分发。有损编码（如 H.265、AV1）是日常使用和网络分发的主流选择，通过合理的参数设置可以在视觉上接近无损效果。简单来说：存档和后期用无损或近无损，发布和分享用有损。',
  },
  {
    question: '如何选择最适合的视频码率？',
    answer: '码率选择取决于分辨率、帧率、内容复杂度和目标画质。以下是一些参考值（以 H.265 为例）：1080p 30fps 标准内容推荐 4-8 Mbps，高动态内容 8-12 Mbps；4K 30fps 标准内容推荐 15-25 Mbps，高动态内容 25-40 Mbps；4K 60fps HDR 内容推荐 40-60 Mbps。建议使用 CRF 模式而非固定码率，让编码器根据内容复杂度动态分配码率。',
  },
  {
    question: 'AV1 编码现在能用了吗？有什么限制？',
    answer: 'AV1 已经可以投入实际使用，但需要注意以下几点：编码速度仍然明显慢于 H.265（使用 libaom 时），不过 SVT-AV1 编码器的出现大大改善了这一问题；解码方面，2020 年后的中高端设备基本支持 AV1 硬解；浏览器支持方面，Chrome、Firefox、Edge 均已支持 AV1 解码；在硬件编码方面，NVIDIA RTX 40 系列、Intel Arc 显卡和 AMD RX 7000 系列均已支持 AV1 硬件编码。',
  },
  {
    question: '视频画质优化的第一步应该做什么？',
    answer: '画质优化的第一步是确保源素材的质量。即使是最优秀的编码参数也无法挽救劣质的源素材。建议：使用尽可能高的拍摄码率和分辨率，选择 10bit 色深拍摄，正确设置曝光和白平衡，使用 log 或 raw 格式获得最大后期空间。只有在源素材质量有保障的前提下，编码优化才有意义。其次，根据内容类型选择合适的编码参数（动画内容 vs 实拍内容的优化方向不同）。',
  },
  {
    question: '为什么我的视频上传到平台后画质变差了？',
    answer: '几乎所有视频平台都会对上传的视频进行二次压缩转码，这是导致画质下降的主要原因。要获得最佳的平台画质，建议：上传远高于平台推荐码率的源文件（如 ProRes 422 HQ 或高码率 H.264/H.265）；对于 YouTube，确保视频获得 VP9 或 AV1 编码（高观看量视频会自动触发）；了解各平台的具体编码规范并按照其推荐参数上传。',
  },
  {
    question: '什么是 VMAF？如何用它评估视频画质？',
    answer: 'VMAF（Video Multi-method Assessment Fusion）是 Netflix 开发的视频质量评估工具，它结合了多种画质指标，通过机器学习模型输出 0-100 的评分（越高越好）。VMAF 评分与人类主观感受高度相关，是目前最可靠的客观画质评估方法之一。使用 FFmpeg 配合 libvmaf 滤镜即可进行 VMAF 计算。通常 VMAF 93 分以上被认为视觉上接近无损。',
  },
];